var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 16,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 14.75,
    width: 24,
    height: 18.5,
    rx: 1.25,
    stroke: "#0A7CC1",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.75 20.5541C32.75 20.0429 33.0612 19.5833 33.5358 19.3935L37.5358 17.7935C38.3568 17.465 39.25 18.0697 39.25 18.9541V29.0459C39.25 29.9303 38.3568 30.535 37.5358 30.2065L33.5358 28.6065C33.0612 28.4167 32.75 27.9571 32.75 27.4459V20.5541Z",
    stroke: "#0A7CC1",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCall);
export default __webpack_public_path__ + "static/media/videoCall.a4a367aef88c6faac981e3ff0ceda9b1.svg";
export { ForwardRef as ReactComponent };